import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {MaterialQualityParametersContainer} from '@widgets/kpis'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const MaterialQualityKpisYesterdayContainer = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezone = useUpmPlantTimezone(plantId)
  const yesterday = moment.tz(timezone).subtract(1, 'day')
  const startOfYesterday = yesterday.clone().startOf('day').toISOString()
  const endOfYesterday = yesterday.clone().endOf('day').toISOString()

  return (
    <MaterialQualityParametersContainer
      plantId={plantId}
      from={startOfYesterday}
      to={endOfYesterday}
      timezone={timezone}
      timeRangeLabel={t('label.yesterday')}
      cardBoxSx={cardBoxSx}
      placeholderWrapperSx={placeholderWrapperSx}
      isVerticalLayout={false}
    />
  )
}
